var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeeDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 388,
    viewBox: "0 0 369 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11621_64146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.43 338.89L184.46 387.27L159.48 338.89H209.43Z",
    fill: "#00132E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.82 311.01L212.53 332.89H156.39L145.09 311.01H223.82Z",
    fill: "#00132E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.18 106.09H258.21L231.94 60.56L253.4 23.37H283.88V0H239.97L211.74 48.88H157.17L128.95 0H85.04V23.37H115.51L136.98 60.56L110.71 106.09H40.74L0 176.68L40.74 247.27H110.78L143.72 304.35H225.19L258.13 247.27H328.18L368.92 176.68L328.18 106.09ZM157.17 72.25H211.74L239 119.44L225.97 142.01L212.7 164.93H156.16L129.92 119.43L157.17 72.25ZM54.19 223.9L26.91 176.68L54.19 129.46H108.75L135.96 176.62L108.67 223.9H54.19ZM211.74 280.98H157.17L129.96 233.86L156.24 188.3H212.68L238.96 233.85L211.74 280.98ZM314.73 223.9H260.24L232.96 176.62L260.17 129.46H314.73L342.01 176.68L314.73 223.9Z",
    fill: "#00132E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11621_64146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 368.92,
    height: 387.27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeDark);
export default __webpack_public_path__ + "static/media/BeeDark.700952aa8c8b4ca39ef06f45498f510d.svg";
export { ForwardRef as ReactComponent };